/**
 * App-wide 1:1 call surface — renders the incoming-call overlay and the active
 * call screen from the `calls` store (driven by the SDK's CallsModule attached
 * in `useOwnUserChannel`). Mounted once in ProtectedRoute so a ring shows on any
 * authed page, not just the chat tab.
 */
import { IncomingCallOverlay } from './incoming-call-overlay'
import { CallScreen } from './call-screen'
import { useCallsStore } from './store/calls.store'

export function GlobalCallLayer() {
  const incoming = useCallsStore((s) => s.incoming)
  const active = useCallsStore((s) => s.active)
  
  const acceptIncoming = useCallsStore((s) => s.acceptIncoming)
  const declineIncoming = useCallsStore((s) => s.declineIncoming)
  const endActive = useCallsStore((s) => s.endActive)

  return (
    <>
      {incoming && (
        <IncomingCallOverlay
          callerName={incoming.name}
          callerImage={incoming.imageUrl}
          contactId={incoming.id}
          isVideo={incoming.mode === 'video'}
          onAccept={acceptIncoming}
          onDecline={declineIncoming}
        />
      )}
      {active && (
        <CallScreen
          name={active.name}
          imageUrl={active.imageUrl}
          contactId={active.id}
          mode={active.mode}
          connected={active.state === 'connected'}
          onClose={endActive}
        />
      )}
    </>
  )
}
